import State from 'store/State';
import { DataServices } from 'store/Services';
import { WidgetId } from 'widgets/WidgetId';
import { MarketDataRequest } from 'marketData/MarketDataRequest';
import {
    extractSymbolFromPayload,
    FillsGraphStreamedDataConfiguration,
    getFillsGraphStreamRequestBySymbolInfosForSymbols,
    getFillsGraphStreamRequestBySymbolWithStreamKey,
} from 'widgets/fillsGraph/store/streamedData/FillsGraphStreamedDataHelpers';
import { buildFillsMarketRequests } from 'widgets/fillsGraph/store/data/marketData';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { FillsGraphByOrderIdOrSymQtyStreamRequestWithSymQty } from 'communication/types/fillsGraph/FillsGraphByOrderIdOrSymQtyStreamRequest';
import flatten from 'lodash/flatten';

export async function getMarketDataRequests(
    state: State,
    services: DataServices,
    id: WidgetId
): Promise<MarketDataRequest[]> {
    const request = await getFillsGraphStreamRequestBySymbolWithStreamKey(
        state,
        services,
        id
    );
    if (!request) {
        return [];
    }

    return getMarketDataRequestsForPayload(request.payload);
}

export async function getMarketDataRequestForSymbols(
    state: State,
    services: DataServices,
    symbols: string[],
    config: FillsGraphStreamedDataConfiguration
): Promise<MarketDataRequest[]> {
    const infos = await getFillsGraphStreamRequestBySymbolInfosForSymbols(
        state,
        services,
        symbols,
        config
    );
    const promises = await Promise.all(
        infos.map((requestInfo) =>
            getMarketDataRequestsForPayload(requestInfo.payload)
        )
    );

    return flatten(promises);
}

function getMarketDataRequestsForPayload(
    payload: FillsGraphByOrderIdOrSymQtyStreamRequestWithSymQty
): MarketDataRequest[] {
    const { symbology, indexSym, indexSymbology } = payload;

    const symbol = extractSymbolFromPayload(payload);

    return buildFillsMarketRequests(
        symbology as SymbologyValues,
        indexSymbology as SymbologyValues,
        symbol,
        indexSym
    );
}
